export const urls = {
  GET_PREGLED_TESTIRANJA: 'DnevnaEvidencija/dnevnik_pregled_testiranja',
  GET_KONVERZACIJE_TESTIRANJA:
    'DnevnaEvidencija/vrati_konverzacije_testiranja_za_dane',
  GET_KONVERZACIJA_ZA_OZNAKU_TESTIRANJE:
    'DnevnaEvidencija/vracanje_konverzacije_za_oznaku_testiranje',
  SLANJE_EMAILA_TESTIRANJA: 'DnevnaEvidencija/slanje_emaila_testiranje',
};
